<template>
  <transition name="fade">
    <div
      v-show="toastShow"
      class="toast"
      :class="toastType"
    >
      <img
        v-show="icon"
        class="icon"
        :src="icon"
        alt
      />
      <p v-show="toastString">{{toastString}}</p>
      <p
        v-show="toastSecondTitle"
        class="toast-title"
      >{{toastSecondTitle}}</p>
      <p
        v-show="toastSecondString"
        class="toast-word"
      >{{toastSecondString}}</p>
    </div>
  </transition>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class Toast extends Vue {
  toastShow = false;
  @Prop({ type: String }) toastString!: '';
  @Prop({ type: String }) toastSecondTitle!: '';
  @Prop({ type: String }) toastSecondString!: '';
  @Prop({ type: String }) toastType!: '';
  @Prop({ type: String }) icon!: '';
}
</script>

<style lang="scss" scoped>
@import '../../style/enrolment.scss';

.toast {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 100000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: $toast-width;
  height: $toast-height;
  // padding: 38px 60px;
  background: rgba($color: #303030, $alpha: 0.8);
  // padding: 40px 60px;
  border-radius: 10px;
  transform: translate(-50%, -50%);
  .icon {
    width: $toast-icon-width;
    height: $toast-icon-height;
    margin-bottom: 12px;
  }

  p {
    color: $html-color;
    font-size: 28px;
    line-height: 1.5;
  }
}
.first-level {
  width: $toast-first-level-width;
  height: $toast-first-level-height;
  border-radius: 12px;
}
.second-level {
  width: $toast-second-level-width;
  height: $toast-second-level-height;
  border-radius: 16px;
  .toast-title {
    margin: 0 0 16px;
    color: $html-color;
    font-weight: $html-font-weight;
    font-size: 36px;
  }
  .toast-word {
    color: #a2a2a2;
  }
}
</style>